const STORAGE_KEYS = {
    accessToken: 'admin:accessToken',
    adminId: 'admin:adminId',
    role: 'admin:role',
    accessMode: 'admin:accessMode',
}

const LEGACY_STORAGE_KEYS = {
    accessToken: 'accessToken',
    adminId: 'adminId',
    role: 'role',
}

export const ADMIN_ACCESS_MODES = {
    DEFAULT: 'default',
    COUNTRY_ANALYTICS_ONLY: 'countryAnalyticsOnly',
}

const getStorageItem = (key, legacyKey) => {
    return localStorage.getItem(key) || (legacyKey ? localStorage.getItem(legacyKey) : null)
}

const removeStorageItem = (key, legacyKey) => {
    localStorage.removeItem(key)

    if (legacyKey) {
        localStorage.removeItem(legacyKey)
    }
}
const parseStoredNumber = (value) => {
    if (value === null || value === undefined || value === '') {
        return null
    }

    const parsedValue = Number(value)
    return Number.isNaN(parsedValue) ? null : parsedValue
}

const setStorageItem = (key, legacyKey, value) => {
    if (value === undefined || value === null) {
        return
    }

    localStorage.setItem(key, String(value))

    if (legacyKey) {
        localStorage.removeItem(legacyKey)
    }
}

export const getAdminSession = () => ({
    accessToken: getStorageItem(STORAGE_KEYS.accessToken, LEGACY_STORAGE_KEYS.accessToken),
    adminId: parseStoredNumber(getStorageItem(STORAGE_KEYS.adminId, LEGACY_STORAGE_KEYS.adminId)),
    role: parseStoredNumber(getStorageItem(STORAGE_KEYS.role, LEGACY_STORAGE_KEYS.role)),
    accessMode: getStorageItem(STORAGE_KEYS.accessMode) || ADMIN_ACCESS_MODES.DEFAULT,
})

export const setAdminSession = (sessionValues = {}) => {
    setStorageItem(STORAGE_KEYS.accessToken, LEGACY_STORAGE_KEYS.accessToken, sessionValues.accessToken)
    setStorageItem(STORAGE_KEYS.adminId, LEGACY_STORAGE_KEYS.adminId, sessionValues.adminId)
    setStorageItem(STORAGE_KEYS.role, LEGACY_STORAGE_KEYS.role, sessionValues.role)
    setStorageItem(STORAGE_KEYS.accessMode, null, sessionValues.accessMode || ADMIN_ACCESS_MODES.DEFAULT)
}

export const setAdminAccessToken = (accessToken) => {
    setStorageItem(STORAGE_KEYS.accessToken, LEGACY_STORAGE_KEYS.accessToken, accessToken)
}

export const setAdminAccessMode = (accessMode) => {
    setStorageItem(STORAGE_KEYS.accessMode, null, accessMode || ADMIN_ACCESS_MODES.DEFAULT)
}

export const clearAdminSession = () => {
    removeStorageItem(STORAGE_KEYS.accessToken, LEGACY_STORAGE_KEYS.accessToken)
    removeStorageItem(STORAGE_KEYS.adminId, LEGACY_STORAGE_KEYS.adminId)
    removeStorageItem(STORAGE_KEYS.role, LEGACY_STORAGE_KEYS.role)
    removeStorageItem(STORAGE_KEYS.accessMode)
}

export const isAdminAuthenticated = () => {
    return Boolean(getStorageItem(STORAGE_KEYS.accessToken, LEGACY_STORAGE_KEYS.accessToken))
}

export const isCountryAnalyticsOnlySession = () => {
    return getAdminSession().accessMode === ADMIN_ACCESS_MODES.COUNTRY_ANALYTICS_ONLY
}
